<template>
  <div id="app">
    <div
      v-if="$root.ready && overflow"
      class="ready-overflow"
      @click="openWebsite()"
    >
      <button
        class="btn btn-outline-primary text-uppercase"
        @click="openWebsite()"
      >
        Buka Undangan
      </button>
    </div>

    <AGWAudio ref="audio" :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :images="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro">
        <!-- <AGWPawiwahan :parent="this" id="pawiwahan" class="py-5"/> -->
        <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes"/>
      </AGWIntro>


      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="" />
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d986.4015113777067!2d115.40283182917557!3d-8.537571673372602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwMzInMTUuMyJTIDExNcKwMjQnMTIuMiJF!5e0!3m2!1sen!2sid!4v1603420141564!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.537597,115.403378/@-8.5375957,115.4028308,19z/data=!4m2!4m1!3e0"
        :location="location"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/20200916090755_IMG_4354__ybXMlJxBUm.jpg'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG20200816125704_GAG3r87Zc.jpg'
const ImageHero3 = 'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/20200916090808_IMG_4358_Z6gnjvA-GQB4.jpg'
const ImageHero4 = 'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG_20200623_103310_yf2jNTO56K.jpg?tr=w-1024,ar-3-2'

import Audio from "@/assets/audio/maroon-5.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryTwo";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Metatah',
      backgrounds: [
        ImageHero1, 
        ImageHero2, 
        ImageHero3,
        ImageHero4,
      ],
      bgActive: 0,
      overflow: true,
      dividerHeight: 0,
      location: "Jl. Puputan No. 10, Br. Mergan, Klungkung - Bali",
      // date: "2020-04-05",
      time: {
        start: this.$moment("2020-11-08 11:00"),
        end: "Selesai"
      },
      wedding: {},
      mepandes: [
        {
          name: 'Putu Sumi Merta Jayanthi, S.Kom',
          image: 'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Putu_Sumi_Merta_Jayanthi_1__RLWtu3_VJHY.jpg'
        },
        {
          name: 'Made Siska Dwi Jayanthi, S.E',
          image: 'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Made_Siska_Dwi_Jayanthi_F9Fqp63W5.jpg'
        },
        {
          name: 'Komang Ayu Manik Trisna Jayanthi',
          image: 'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Komang_Ayu_Manik_Trisna_Jayanthi_wd7xzS7wO_0Y.jpg'
        },
      ],
      gallery: [
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG20200816125704_1DsF5Cnhd.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Made_Siska_Dwi_Jayanthi_HoLyDA6HAq.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/PicsArt_10-20-11.52.12_q4q0_NqpZPJ.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG20200916061719_YXEPQ03ypW.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG20200916061724_RXsUXyHxAN.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG20200816125640_kD87Ix4S_.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Komang_Ayu_Manik_Trisna_Jayanthi_1__4fZQj8s4wU2t.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Made_Siska_Dwi_Jayanthi_1__m_eMOaLsJMG.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/20200916090808_IMG_4358_Z6gnjvA-GQB4.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Putu_Sumi_Merta_Jayanthi_1__ZRZjLE4JJ.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/PicsArt_10-20-11.53.20_mFixOvx_W.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/20200916090829_IMG_4362_L1DAJuTm5.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG20200916085509_AOQ4FZROra.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Komang_Ayu_Manik_Trisna_Jayanthi_zXdeiw0N3y.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG_20200926_080833_Sc4Er0xYru.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/Putu_Sumi_Merta_Jayanthi_tTT2izcL_7.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/20200916090755_IMG_4354__ybXMlJxBUm.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/jayanthi/IMG_20200623_103310_yf2jNTO56K.jpg',
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.sw.refreshing) return;
        this.sw.refreshing = true;
        window.location.reload();
      });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    }
  }
};
</script>
